import { BaseChart, Retry } from '@components/common';
import React from 'react';
import useToolbox from '../../hooks/useToolbox';
import Header from './Header/Header';

const cardStyle = {
  height: '100%',
  backgroundColor: 'white',
  borderRadius: 6,
  borderStyle: 'solid',
  borderWidth: 'thin',
  borderColor: '#dedede',
};

const UsageMetricCard = ({ metric }) => {
  const { chartInstanceRefCb } = useToolbox({ metric });

  return (
    <div style={cardStyle}>
      <Header metric={metric} />
      <Retry>
        <BaseChart
          key={metric}
          chartId={metric}
          chartInstanceRefCb={chartInstanceRefCb}
          style={{ height: '150px', marginTop: '-15px' }}
        />
      </Retry>
    </div>
  );
};

export default UsageMetricCard;
